import { render, staticRenderFns } from "./ClientAllUsers.vue?vue&type=template&id=c2532282"
import script from "./ClientAllUsers.vue?vue&type=script&lang=js"
export * from "./ClientAllUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports